import { useSelector } from "react-redux";
import { getQuickSearchCriteriaSelectionType } from "./selectors";

export const useQuickSearchCriteriaSelectionType = () => {
	return useSelector(getQuickSearchCriteriaSelectionType);
};
